import { AuthState } from "./auth-state.interface";

export function createAuthState(): AuthState {
  return {
    userId: null,
    error: null,
  };
}
